import {
  ClickOutsideDetector,
  IconBlock,
  IconDownload,
  IconLoader,
  IconSelected,
  IconTrash,
  PermissionEnum,
} from '@ui/src';
import { OrganizationType } from '../../../../hoc/common/types';
import { DocumentActionsTypes } from '../types';
import {
  CustomerDocument,
  CustomerDocumentStatus,
} from '../../../../hoc/common/documents/types';
import ChangeStatusButton from './change-status-buttons';

import cn from '../styles.module.css';

const DocumentActions = ({
  otherActionsMenuVisible,
  type,
  setOtherActionsMenuVisible,
  activePermissions,
  statusChangeInProgress,
  setSelectedStatus,
  allowedCategories,
  documentsByCategoryId,
  allDocuments,
  changeCustomerDocumentsStatusAction,
  selectedStatus,
  setDeletePopupVisible,
  getFiles,
  downloadInProgress,
  isFetching,
}: DocumentActionsTypes) => (
  <ClickOutsideDetector
    className={cn.selectedDocumentsOtherActions}
    setOptionsListVisible={setOtherActionsMenuVisible}
  >
    <>
      <button
        type="button"
        className={cn.otherActionsMenuButton}
        aria-label="Other actions"
        onClick={() => setOtherActionsMenuVisible(!otherActionsMenuVisible)}
      >
        <span />
        <span />
        <span />
      </button>
      {otherActionsMenuVisible && (
        <ul className={cn.otherActionsMenuList}>
          {((type === OrganizationType.INDIVIDUAL &&
            activePermissions?.includes(
              PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
            )) ||
            (type === OrganizationType.CORPORATE &&
              activePermissions?.includes(
                PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
              ))) && (
            <>
              <li>
                <ChangeStatusButton
                  statusChangeInProgress={statusChangeInProgress}
                  setSelectedStatus={setSelectedStatus}
                  statusForChange={CustomerDocumentStatus.ACCEPTED}
                  allowedCategories={allowedCategories}
                  documentsByCategoryId={documentsByCategoryId}
                  allDocuments={allDocuments}
                  changeCustomerDocumentsStatusAction={
                    changeCustomerDocumentsStatusAction
                  }
                  selectedStatus={selectedStatus}
                  buttonText="Accept"
                  icon={
                    <IconSelected
                      className={`${cn.selectedDocumentsButtonIcon} ${cn.selectedDocumentsButtonIconMargin}`}
                      width={14}
                      height={14}
                    />
                  }
                />
              </li>
              <li>
                <ChangeStatusButton
                  statusChangeInProgress={statusChangeInProgress}
                  setSelectedStatus={setSelectedStatus}
                  statusForChange={CustomerDocumentStatus.REJECTED}
                  allowedCategories={allowedCategories}
                  documentsByCategoryId={documentsByCategoryId}
                  allDocuments={allDocuments}
                  changeCustomerDocumentsStatusAction={
                    changeCustomerDocumentsStatusAction
                  }
                  icon={
                    <IconBlock
                      className={`${cn.selectedDocumentsButtonIcon} ${cn.selectedDocumentsButtonIconMargin}`}
                      width={16}
                      height={16}
                    />
                  }
                  selectedStatus={selectedStatus}
                  buttonText="Reject"
                />
              </li>
            </>
          )}
          <li>
            <button
              type="button"
              className={cn.otherActionMenuButton}
              disabled={downloadInProgress || isFetching}
              onClick={() => {
                const selectedDocuments: CustomerDocument[] = [];

                if (allowedCategories && documentsByCategoryId) {
                  allowedCategories.forEach((item) => {
                    if (documentsByCategoryId[item.id]) {
                      documentsByCategoryId[item.id].forEach((category) => {
                        category.documents?.forEach((document) => {
                          if (document.isSelected) {
                            selectedDocuments.push(document);
                          }
                        });
                      });
                    }
                  });
                }

                if (allDocuments) {
                  allDocuments.all.forEach((category) => {
                    category.documents?.forEach((document) => {
                      if (
                        document.isSelected &&
                        !selectedDocuments.find(
                          (selected) => selected.id === document.id,
                        )
                      ) {
                        selectedDocuments.push(document);
                      }
                    });
                  });
                }

                getFiles(selectedDocuments);
              }}
            >
              {downloadInProgress || isFetching ? (
                <IconLoader
                  className={`${cn.selectedDocumentsButtonIcon} ${cn.selectedDocumentsButtonIconMargin}`}
                  width={16}
                  height={16}
                />
              ) : (
                <IconDownload
                  className={`${cn.selectedDocumentsButtonIcon} ${cn.selectedDocumentsButtonIconMargin}`}
                  width={16}
                  height={16}
                />
              )}
              Download
            </button>
          </li>
          {((type === OrganizationType.INDIVIDUAL &&
            activePermissions?.includes(
              PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_DELETE_ACTION,
            )) ||
            (type === OrganizationType.CORPORATE &&
              activePermissions?.includes(
                PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_DELETE_ACTION,
              ))) && (
            <li>
              <button
                type="button"
                className={cn.otherActionMenuButton}
                onClick={() => setDeletePopupVisible(true)}
              >
                <IconTrash
                  className={`${cn.selectedDocumentsButtonIcon} ${cn.selectedDocumentsButtonIconMargin}`}
                  width={16}
                  height={16}
                />
                Delete
              </button>
            </li>
          )}
        </ul>
      )}
    </>
  </ClickOutsideDetector>
);

export default DocumentActions;
